import { StyleSheet } from 'aphrodite';
import { titles } from '../../../styles/colors';
import { BreakPoints, CssSelectors } from '../../../styles/styles';
import { THEME } from '../../../components-v2/Theme/theme';

const footerHeight = 60;

export const styleSheet = StyleSheet.create({
	archiveCheckbox: {
		display: 'inline-flex',
	},
	board: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		maxHeight: 'calc(100vh - 120px)',
	},
	boardHeader: {
		textAlign: 'right',
		flexShrink: 0,
	},
	boardHeaderSubheader: {
		letterSpacing: 0,
		marginTop: 10,
		whiteSpace: 'pre',
	},
	boardHeaderTitle: {
		color: titles,
		fontSize: 18,
	},
	boardHeaderTitles: {
		color: '#767676',
		fontSize: 14,
		lineHeight: '22px',
		textAlign: 'left',
	},
	body: {
		boxSizing: 'border-box',
		padding: '20px 0',
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
	},
	checkboxSection: {
		marginBottom: 20,
	},
	columns: {
		height: 380,
		overflowY: 'auto',
		[BreakPoints.forMinWidth(768)]: {
			height: 'auto',
			maxHeight: 500,
			minHeight: 380,
		},
		[BreakPoints.forMinWidth(1024)]: {
			height: 'auto',
			maxHeight: 660,
			minHeight: 380,
		},
		...CssSelectors.allDescendants(
			{
				marginTop: 20,
			},
			'.edit-kanban-board-column-definition:not(:first-child)'
		),
	},
	columnsFooter: {
		margin: '20px 0',
	},
	footer: {
		alignItems: 'center',
		background: '#fff',
		display: 'flex',
		flexShrink: 0,
		height: footerHeight,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	nameInput: {
		width: '50%',
		marginTop: 8,
	},
	nameLabel: {},
	defaultAssigneesSection: {
		marginTop: THEME.spacing.lg,
		marginBottom: THEME.spacing.lg,
	},
	defaultAssigneesLabel: {
		display: 'block',
	},
	defaultAssigneesSubLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
		marginBottom: THEME.spacing.sm,
	},
});
